import { render, staticRenderFns } from "./inbdetailsgrid.vue?vue&type=template&id=1a744983"
import script from "./inbdetailsgrid.vue?vue&type=script&lang=js"
export * from "./inbdetailsgrid.vue?vue&type=script&lang=js"
import style0 from "./inbdetailsgrid.vue?vue&type=style&index=0&id=1a744983&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports